define 'controller/ReviewAppear', ['jquery'], ($) ->
  class ReviewAppear

    constructor: (@$el) ->
      @_init(@$el)

    _init : (el) ->
      console.log("init has run with " + el)
      @waitForElement(".netreviews_reviews_rate", el)
        .then( (result) ->
          result.setAttribute("itemprop", "ratingValue"))

    waitForElement:(selector, element) ->
      return new Promise(  (resolve)->
          console.log(element.children(selector).first())
          if (element.children(selector).first().length != 0)
            console.log(element.children(selector).first().length != 0)
            return resolve(element.children(selector).first())
          observer = new MutationObserver((mutation)  ->
            if (document.querySelector(selector))
              observer.disconnect()
              return resolve(document.querySelector(selector))
          )

          observer.observe(element.get(0), {childList: true, subtree: true})

      )